import * as Sentry from '@sentry/react';

// Defensive init: no-op when DSN is missing (dev without Sentry, or misconfigured prod).
// Build never fails because of this, runtime never crashes.
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Trace 10 % of transactions in prod; 100 % in dev for fast feedback.
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  });
}
